import { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

import {
  Stage,
  useTutoringActivationJourneyLink
} from "features/tutoring/activation-journey";

import useFetchActivationCode from "./activation-journey/hooks/useFetchActivationCode";

export function useOpenTutoringActivationJourneyIfInactive() {
  const { data } = useFetchActivationCode();
  const VALID_CODE_LENGTH = 10;
  const hasTutoringInactive =
    data?.activationCode?.length === VALID_CODE_LENGTH;
  const linkToTutoringActivation = useTutoringActivationJourneyLink({
    stage: Stage.YearGroup
  });

  return {
    hasTutoringInactive,
    linkToTutoringActivation
  };
}

export function useOpenModalIfInactive() {
  const history = useHistory();
  const { hasTutoringInactive, linkToTutoringActivation } =
    useOpenTutoringActivationJourneyIfInactive();
  const hasShownTutorialModal = useRef<boolean>();
  const setHasShownTutorialModal = () => {
    hasShownTutorialModal.current = true;
  };
  useEffect(() => {
    if (hasTutoringInactive && !hasShownTutorialModal.current) {
      history.replace(linkToTutoringActivation);
      setHasShownTutorialModal();
    }
  }, [history, hasTutoringInactive, linkToTutoringActivation]);
}
